import React, { useState } from "react";
import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import AddIcon from "@mui/icons-material/Add";
import SwitchToggle from "../../components/SwitchToggle";

const ManageBadges = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  const badges = [
    {
      id: "BADG001",
      title: "Consistency King",
      description: "Complete 10 workouts in a month",
      image: "/static/images/badge_placeholder.png",
      unlockTarget: "Workouts ≥ 10",
      status: true,
      userView: "Unlocked", // NEW
    },
    {
      id: "BADG002",
      title: "Hydration Master",
      description: "Drink 2L water daily for 7 consecutive days",
      image: "/static/images/badge_placeholder.png",
      unlockTarget: "7 Day Streak",
      status: false,
      userView: "Locked", // NEW
    },
  ];

  return (
    <>
      <div className="main_title">
        <h1>Manage Achievements & Badges</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          Manage Achievements & Badges
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search Badges"
            />
          </div>

          <div className="right_s">
            <Button className="btn btn_primary" onClick={() => navigate("add")}>
              <AddIcon /> Add Badge
            </Button>
          </div>
        </div>

        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Badge</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Unlock Target</TableCell>
                <TableCell>Badges View</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {badges.map((badge) => (
                <TableRow hover key={badge.id}>
                  <TableCell>{badge.id}</TableCell>
                  <TableCell>
                    <div className="user_block">
                      <figure>
                        <img
                          src={badge.image}
                          alt={badge.title}
                          style={{ objectFit: "contain" }}
                        />
                      </figure>
                      <p>
                        <b>{badge.title}</b>
                      </p>
                    </div>
                  </TableCell>
                  <TableCell>{badge.description}</TableCell>
                  <TableCell>{badge.unlockTarget}</TableCell>
                  <TableCell>
                    <span
                      style={{
                        padding: "6px 12px",
                        borderRadius: "20px",
                        background:
                          badge.userView === "Unlocked" ? "#e8ffe8" : "#ffe8e8",
                        color: badge.userView === "Unlocked" ? "green" : "red",
                        fontWeight: 600,
                        fontSize: "13px",
                      }}
                    >
                      {badge.userView}
                    </span>
                  </TableCell>
                  <TableCell>
                    <SwitchToggle defaultChecked={badge.status} />
                  </TableCell>
                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton
                        onClick={() => navigate("view", { state: { badge } })}
                      >
                        <img src="/static/images/eye_icon.svg" alt="View" />
                      </IconButton>
                      <IconButton
                        onClick={() => navigate("edit", { state: { badge } })}
                      >
                        <img src="/static/images/edit2_icon.svg" alt="Edit" />
                      </IconButton>
                      <IconButton>
                        <img
                          src="/static/images/trash2_icon.svg"
                          alt="Delete"
                        />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
};

export default ManageBadges;
